export default __webpack_public_path__ + "static/bannerImgNew-b1c5d80d99e223bb1ac59aead6b6b831.png";